const projectInfo = [
      {
        id: 1,
        category: "Desktop & Embedded",
        title: "Lab Animal Monitor",
        description:
          "An Animal monitor for lab mice with heartrate and temperature monitoring with remote animal heating control functionality.",
        photo:
          "https://images.pexels.com/photos/9408866/pexels-photo-9408866.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        links: {
          github: "https://github.com/AmineBenaceur/HIFUAnimalMonitor",
          youtube: "https://youtu.be/pChgVMOFTHQ",
          link: "",},
      },
      {
        id: 2,
        category: "Desktop & Embedded",
        title: "Learning Platform",
        description:
          "An online learning platform for students & professors to fascilitate learning, course enrollment submitting & grading assignments, and E-mail communication.",
        photo:
          "https://images.pexels.com/photos/5428003/pexels-photo-5428003.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        links: {
          github: "https://github.com/AmineBenaceur/LearningPlatform",
          youtube: "",
          link: "", },
      },
      {
        id: 3,
        category: "Desktop & Embedded",
        title: "VR Haptic Ping Pong",
        description:
          "A single player virtual Reality Ping Pong game with haptic touch feedback for full immersion. Interfaced with the PHANTOM Omni Device. ",
        photo:
          "https://images.pexels.com/photos/976873/pexels-photo-976873.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        links: {
          github: "https://github.com/AmineBenaceur/HapticPingPong",
          youtube: "https://youtu.be/3jQ1ItvAfz0",
          link: "",},
      },
    {
        id: 4,
        category: "Web Applications",
        title: "TwitchHub",
        description:
          "Twitch streaming website utilizing the Twitch API. Users can sign up, subscribe to various categories and stream relevant videos from Twitch in their feed.",
        photo:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Twitch_Logo.jpg/800px-Twitch_Logo.jpg",
        links: {
          github: "https://github.com/AmineBenaceur/TwitchBlog",
          youtube: "",
          link: "",},
    },
    {
        id: 5,
        category: "Web Applications",
        title: "BookLibrary",
        description:
          "Book library system developed using Laravel and PostgreSQL. Users can login, browse books, view their attributes and put holds on books.",
        photo:
          "https://images.pexels.com/photos/33283/stack-of-books-vintage-books-book-books.jpg?auto=format%2Ccompress&cs=tinysrgb&dpr=2&h=650&w=940",
        links: {
          github: "https://github.com/AmineBenaceur/BookLibrary",
          youtube: "",
          link: "",
        },
      },
      {
        id: 6,
        category: "Desktop & Embedded",
        title: "Client Server TicTacToe",
        description:
          " A TicTacToe desktop game developed in Java. Supports multiple Players at once through a multi-threaded Client/Server design.",
        photo:
          "https://images.pexels.com/photos/3400795/pexels-photo-3400795.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        links: {
          github: "https://github.com/AmineBenaceur/TicTacToeCS",
          youtube: "",
          link: "",},
      },
      {
        id: 7,
        category: "UI Design & Static",
        title: "MoneyWatch - Website",
        description:
          "A website for the MoneyWatch team. Displays information about us, our vision, stakeholders and our published user research findings and methods.",
        photo:
          "https://www.fijitimes.com/wp-content/uploads/2018/12/getty-stock-market-rising_large.jpg",
        links: {
          github: "https://github.com/AmineBenaceur/MoneyWatch",
          youtube: "",
          link: "https://adarshmelethil.github.io/MoneyWatch/",
        },
      },
      {
        id: 8,
        category: "UI Design & Static",
        title: "MyPortfolio",
        description:
          "The portfolio website that you are currently looking at! Originally built for personal use in ReactJS,  but will however soon be available to others as a template.",
        photo:
          "https://cdn-images-1.medium.com/max/2600/1*qXcjSfRj0C0ir2yMsYiRyw.jpeg",
        links: {
          github: "https://github.com/AmineBenaceur/aminebenaceur.github.io",
          youtube: "",
          link: "https://aminebenaceur.github.io/",
        },
      },
      {
        id: 9,
        category: "Web Applications",
        title: "FrogBlog",
        description:
          "Blogging and image sharing application developed using Ruby on Rails and PostgreSQL.",
        photo:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Ruby_On_Rails_Logo.svg/1200px-Ruby_On_Rails_Logo.svg.png",
        links: {
          github: "https://github.com/AmineBenaceur/FrogBlog",
          youtube: "",
          link: "",
        },
      },
      {
        id: 10,
        category: "Web Applications",
        title: "MyBlog",
        description:
          "A blogging application built using laravel along with PostgreSQL. Allows Users to Sign up and easily post blog content and images to their feed.",
        photo:
          "https://i2.wp.com/storage.googleapis.com/blog-images-backup/1*2gKr79YTmj2MkP8zLOn-bg.png?resize=1201%2C401&ssl=1",
        links: {
          github: "https://github.com/AmineBenaceur/MyBlog",
          youtube: "",
          link: "",
        },
      },
      {
        id: 11,
        category: "Desktop & Embedded",
        title: "Client Manager",
        description:
          "A functional java application which implements the MVC design pattern to track clients and info for a company.",
        photo:
          "https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        links: {
          github: "https://github.com/AmineBenaceur/ClientManager",
          youtube: "",
          link: "",},
      },
      {
        id: 12,
        category: "Desktop & Embedded",
        title: "Inventory Tracker",
        description:
          "A Java application to track inventory items in stock, make orders, browse and search tools & items by various attriubutes.",
        photo:
          "https://images.pexels.com/photos/1797428/pexels-photo-1797428.jpeg?auto=format%2Ccompress&cs=tinysrgb&dpr=2&h=650&w=940",
        links: {
          github: "https://github.com/AmineBenaceur/InventoryManager",
          youtube: "",
          link: "",},
    },
      {
        id: 13,
        category: "UI Design & Static",
        title: "ToDoList",
        description:
          "A front-end To-do list application developed using ReactJS and bootstrap. Was built to use axios as an HTTP client, but was deployed as a static application.",
        photo:
          "https://www.fijitimes.com/wp-content/uploads/2018/12/getty-stock-market-rising_large.jpg",
        links: {
          github: "https://github.com/AmineBenaceur/todo",
          youtube: "",
          link: "https://aminebenaceur.github.io/todo/",
        },
      },
      {
        id: 14,
        category: "UI Design & Static",
        title: "MoneyWatch - Prototype",
        description:
          "A Human-Computer Interaction focused Prototype showcasing how investors can use our platform to analyze the market. ",
        photo:
          "https://i0.wp.com/wptavern.com/wp-content/uploads/2018/11/Screen-Shot-2018-11-19-at-8.43.27-PM.png?ssl=1",
        links: {
          github: "",
          youtube: "https://www.youtube.com/watch?v=35hq-JhyyAo&t=3s",
          link: "",
        },
      },
    ];
    export default projectInfo